import { TWEETS_CHANGE } from "../../actions/types";
import { TWEETS_API } from "../../constants/_api";
import queryTweets from "./queryTweets";
import asyncActionErrorHandler from "../../utils/asyncActionErrorHandler";

const dispatchResponse = (dispatch, payload) =>
  dispatch({
    type: TWEETS_CHANGE,
    payload
  });

const dispatchFailure = dispatch =>
  dispatch({
    type: TWEETS_CHANGE,
    payload: {}
  });

export const getTweets = (keyword, token) =>
  asyncActionErrorHandler(async dispatch => {
    if (!keyword) {
      return;
    }
    let requestTime=Date.now()
    let url = `${TWEETS_API}?q=${keyword}`;
    let result = await queryTweets(url, token);
    result = await result.json();

    if (result.message === "SUCCESS") {
      let responseTime = Date.now()
      let TimeTaken=(responseTime - requestTime)/1000
      let RequestTime= new Date().toTimeString()
      let ResponseTime = new Date().toTimeString()
      TimeTaken = TimeTaken + "seconds"
      result.body={
          ...result.body,
          keyword,
          RequestTime,
          ResponseTime,
          TimeTaken
      }
      dispatchResponse(dispatch, result.body);
    } else {
      dispatchFailure(dispatch);
    }
  }, dispatchFailure);
